module.exports = __webpack_public_path__ + "static/media/AboutPage2Img5.31facf1e.png";